import { EVENTS } from "@/lib/siteData";
import { Flower2 } from "lucide-react";

export default function Events() {
  return (
    <section
      id="events"
      className="py-24 md:py-32 bg-accent/40"
      data-testid="events-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16 text-center mx-auto">
          <p className="eyebrow" data-testid="events-overline">Events We Host</p>
          <h2
            className="mt-4 font-headings text-3xl md:text-5xl text-primary leading-tight"
            data-testid="events-heading"
          >
            Celebrating all of life's precious milestones.
          </h2>
          <div className="my-8 divider-ornament max-w-xs mx-auto">
            <Flower2 size={16} strokeWidth={1.4} />
          </div>
          <p className="font-body text-base md:text-lg text-foreground/75 leading-relaxed">
            No matter the scale or style of your celebration, our venue is fully equipped to host
            diverse cultural and social events.
          </p>
        </div>

        <div className="space-y-16 md:space-y-24">
          {EVENTS.map((ev, i) => {
            const reversed = i % 2 === 1;
            return (
              <article
                key={ev.title}
                className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center"
                data-testid={`event-${i}`}
              >
                <div
                  className={`md:col-span-7 ${reversed ? "md:order-2" : ""}`}
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={ev.image}
                      alt={ev.title}
                      className="w-full h-[280px] md:h-[440px] object-cover img-hover"
                      loading="lazy"
                    />
                  </div>
                </div>
                <div
                  className={`md:col-span-5 ${reversed ? "md:order-1" : ""}`}
                >
                  <p className="eyebrow">{String(i + 1).padStart(2, "0")} · Occasion</p>
                  <h3 className="mt-3 font-headings text-2xl md:text-3xl text-primary leading-snug">
                    {ev.title}
                  </h3>
                  <p className="mt-5 font-body text-base md:text-lg text-foreground/80 leading-relaxed">
                    {ev.body}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
